var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"myGraph"}}),_vm._v(" "),(_vm.suggestions.length === 0)?_c('div',{staticStyle:{"height":"100%","width":"100%","position":"absolute","top":"0"}},[_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"150px"}},[_vm._v("No suggestions")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3df424","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/FoamTreeSuggestionsBox.vue
// module id = null
// module chunks = 